import { Outlet, useLocation } from 'react-router-dom';
import { useWebSocket } from '../../hooks/useWebSocket';
import { cleanupConnectionEvents, initializeConnectionEvents } from '../../api/events/connectionEvents';
import { useEffect } from 'react';
import { PlayerContext } from '../PlayerContext';
import { sendAnalytics } from '@playcastdotio/Analytics';
import { getPersistentPlayerId } from '../../api';

export const PlayerConnectionWrapper = () => {
  const location = useLocation();
  useWebSocket();
  useEffect(() => {
    initializeConnectionEvents();

    const isQuickstart = location.pathname.startsWith('/q/');
    if (isQuickstart) {
      const quickstartSlug = location.pathname.split('/q/')[1]?.split('/')[0] || undefined;
      sendAnalytics({
        name: 'Connection Events Initialized',
        role: 'player',
        flow: 'quickstart',
        quickstartSlug,
        persistentId: getPersistentPlayerId(),
      });
    }

    return () => {
      cleanupConnectionEvents();
    };
  }, [location.pathname]);
  return (
    <PlayerContext>
      <Outlet />
    </PlayerContext>
  );
};
